/**
 * 更新の応答が返らなかった（timeout・通信断）。認証の失敗ではないので、
 * セッションを終えずに呼び出し側へ返す。後で操作し直せば再試行される。
 */
export class RefreshUnavailableError extends Error {
  readonly code?: string;
  readonly cause?: unknown;
  constructor(cause: unknown) {
    super((cause as Error)?.message ?? 'Token refresh did not respond');
    this.name = 'RefreshUnavailableError';
    this.code = (cause as { code?: string })?.code;
    this.cause = cause;
  }
}

export function isNoResponse(error: unknown): boolean {
  const e = error as { isAxiosError?: boolean; response?: unknown };
  return Boolean(e?.isAxiosError) && !e.response;
}

/** 待っている間に、別のタブでログインし直された（別のセッション・別の利用者）。 */
export class SessionChangedError extends Error {
  constructor() {
    super('The session was replaced in another tab');
    this.name = 'SessionChangedError';
  }
}

/**
 * この接続では Cookie を書き換える処理をタブ間で直列にできない（Web Locks が無い・
 * secure context でない）。直列にできないまま送らない（PR #90 レビュー P2）。
 * 認証の失敗ではないので、セッションは終えない。ログイン画面で理由を表示する
 * （config/sessionEnvironment.ts）。
 */
export class SessionEnvironmentError extends Error {
  constructor() {
    super('Web Locks are not available; the admin console needs https or localhost');
    this.name = 'SessionEnvironmentError';
  }
}

/** 認証の失敗ではなく、セッションを終えずに呼び出し側へ返す失敗。 */
export function isTransientSessionError(error: unknown): boolean {
  return error instanceof RefreshUnavailableError || error instanceof SessionEnvironmentError;
}
